
// Play video
document.addEventListener('DOMContentLoaded', function () {
    const playButtonRecette = document.querySelector('.mm-play-video-recipe');
    const videoWrapper = document.querySelector('.mm-wrapper-video-full-recette');
    const closeButtonRecette = document.querySelector('.mm-video-close-btn');
    const filter = document.querySelector('.mm-filter-mega-menu');

	if (playButtonRecette) {
        playButtonRecette.addEventListener('click', function () {
            videoWrapper.style.display = 'flex';
			filter.style.pointerEvents = 'unset';
            document.body.style.overflow = 'hidden';
            showBgFilter(20);
        });
    }

	if (closeButtonRecette) {
        closeButtonRecette.addEventListener('click', function () {
            videoWrapper.style.display = 'none';
            filter.style.display = 'none';
			filter.style.pointerEvents = 'none';
            document.body.style.overflow = '';
            hideBgFilter();
        });
    }

	filter.addEventListener('click', function () {
        videoWrapper.style.display = 'none';
        document.body.style.overflow = '';
		filter.style.pointerEvents = 'none';
        hideBgFilter();
    });
});
